import { render, staticRenderFns } from "./padlet_card_actions.vue?vue&type=template&id=2d104f81&scoped=true&"
import script from "./padlet_card_actions.vue?vue&type=script&lang=js&"
export * from "./padlet_card_actions.vue?vue&type=script&lang=js&"
import style0 from "./padlet_card_actions.vue?vue&type=style&index=0&id=2d104f81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d104f81",
  null
  
)

export default component.exports